import {domain} from '@/utils/domain'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk';
import {getWxSignature} from '@/utils/api'
export default {
  data() {
    return {
      config: {
        url: '', // 网址，默认使用 window.location.href
        source: "中电标协数据存储专业委员会", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: [
          "wechat",
          "weibo",
          "qzone",
          "qq",
        ], // 启用的站点
        // disabled: ["google", "facebook", "twitter"], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
      }
    }
  },
  methods: {
    initWxConfig(shareData) {
      const data = {
        url: encodeURIComponent(location.href)
      }
      getWxSignature(data).then(res => {
        if (!res.code) {
          let result = res.result
          wx.config({
            debug: false,//生产环境需要关闭debug模式
            appId: result.appid,
            timestamp: result.timestamp,//生成签名的时间戳
            nonceStr: result.nonceStr,//生成签名的随机字符串
            signature: result.signature,//签名
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          });
          wx.ready(() => {
            wx.onMenuShareTimeline(shareData);
            wx.onMenuShareAppMessage(shareData);
            wx.error((res) => {
              console.log(res)
            });
          });
        }
      })
    },
    getImgSrc(rich) {
      var imgList = [];
      rich.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        imgList.push(capture);
      });
      return imgList;
    },
    // 筛选指定条件树状数据
    dealData(nodes, predicate) {
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return [];
      }
      const newChildren = [];
      for (const node of nodes) {
        if (predicate(node)) {
          // 如果节点符合条件，直接加入新的节点集
          newChildren.push(node);
          node.children = this.dealData(node.children, predicate);
        } else {
          // 如果当前节点不符合条件，递归过滤子节点，
          // 把符合条件的子节点提升上来，并入新节点集
          newChildren.push(...this.dealData(node.children, predicate));
        }
      }
      return newChildren;
    },
    // 限制输入框输入数字，zs：整数部分位数 xs: 小数部分位数
    limitControlLine (val, zs, xs) {
      let value = val;
      if (isNaN(val)) {
        value = String(val).replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        value = value.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
        value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      }
      if (value.charAt(0) === '0' && val.charAt(1) !== '.') {
        value = "0";
      }
      if (value.charAt(0) === '.') {
        value = "0." + value.split('.')[1] ;
      }
      if (Number(value) >Math.pow(10,zs)) {
        value = (value.split('.')[1] === undefined) ? value.substr(0,zs): value.substr(0,zs) + "." + value.split('.')[1];
      }
      if(value.indexOf('.')>0){
        value=value.slice(0,value.indexOf('.')+ (xs + 1));
      }
      return value;
    },
    // 预览附件公共方法
    commonPreviewAffix(file) {
      let url = file.filePath || file.url
      setTimeout(() => {
        window.open(`${domain.Preview_Domain}?url=${encodeURIComponent(Base64.encode(url))}`)
      })
    },
  }
}
